/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Breadcrumb_FinanceInputs */



/**
* | output |
* | --- |
* | "Finance" |
*
* @param {Partner_Billing_Board_Breadcrumb_FinanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_breadcrumb_finance = /** @type {((inputs?: Partner_Billing_Board_Breadcrumb_FinanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Breadcrumb_FinanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Finanzen")
	return /** @type {LocalizedString} */ ("Finance")
});